module.exports = __webpack_public_path__ + "img/topSon.78d67a8e.svg";